import React from "react";
import { Row, Col, Button, Input, Drawer, Form, Checkbox, Select, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import Close from "../../../../assets/images/close-x.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";

const { Option } = Select;

const CashManagementDrawer = ({
  addCashFlag,
  setAddCashFlag,
  cashAddInFlag,
  cashManagementForm,
  handleCahInOut,
  onChangeCheckbox,
  posConfig,
  cashOut,
  setCashOut,
  pettyCashOut,
  setPettyCashOut,
  bankTransfer,
  cashIn,
  setCashIn,
  pettyCashIn,
  setPettyCashIn,
  expenseCategories,
  financialAccounts,
  handleCashManagement,
  handleAmountChange,
  handleCashInNote,
  focusedField,
  setFocusedField,
  amountInputRef,
  width,
  fileInputRef,
  handleFileUpload,
  uploadedFileUrl,
  uploadedFileName,
  setUploadedFileUrl,
  setUploadedFileName,
  uploading,
}) => {
  return (
    <Drawer
      closable={false}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "4vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            {cashAddInFlag ? "Remove Cash" : "Add Cash"}
          </p>
          <img
            src={Close}
            onClick={() => {
              cashManagementForm.resetFields();
              setAddCashFlag(false);
              setCashOut(false);
              setPettyCashOut(false);
              setCashIn(false);
              setPettyCashIn(false);
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={addCashFlag}
      className="filter"
      headerStyle={{ borderBottom:"none" }}
      bodyStyle={{backgroundColor: "#f3f4f9"}}
      onClose={() => {
        cashManagementForm.resetFields();
        setAddCashFlag(false);
      }}
      //  id="sm-drawer-close"
      height="75vh"
    >
      <Form form={cashManagementForm} onFinish={handleCahInOut} layout="vertical" style={{ fontSize: "1vw" }}>
        <Row style={{ padding: "2% 0 0% 0" }}>
          <Col span={1} />
          <Col span={11} style={{ paddingRight: "1vw" }}>
            {cashAddInFlag ? (
              <Row>
                <Col span={2} />
                {posConfig?.cashOut === "Y" ? (
                  <Col span={10}>
                    <Form.Item name={"cashOut"} style={{ marginLeft: "8vw", fontSize: "1vw" }}>
                      <Checkbox
                        style={{
                          fontWeight: 500,
                          color: "#0F0718",
                          fontSize: "1.25em",
                          transform: "scale(1.05)",
                          lineHeight: "normal",
                        }}
                        checked={cashOut}
                        onChange={onChangeCheckbox}
                      >
                        Cash Out
                      </Checkbox>
                    </Form.Item>
                  </Col>
                ) : null}
                <Col span={10}>
                  {posConfig?.allowPettyCashExpenses === "Y" ? (
                    <Form.Item name={"pettyCashOut"} style={{ marginLeft: posConfig?.cashOut !== "Y" ? "8vw" : 0, fontSize: "1vw" }}>
                      <Checkbox
                        checked={pettyCashOut}
                        style={{
                          fontWeight: 500,
                          color: "#0F0718",
                          fontSize: "1.25em",
                          transform: "scale(1.05)",
                          lineHeight: "normal",
                        }}
                        onChange={onChangeCheckbox}
                      >
                        Expenses
                      </Checkbox>
                    </Form.Item>
                  ) : null}
                </Col>
                <Col span={10}>
                  {posConfig?.enableBankTransferInCashOut === "Y" ? (
                    <Form.Item name={"bankTransfer"} style={{ marginLeft: posConfig?.enableBankTransferInCashOut === "Y" ? "4vw" : 0, fontSize: "1vw" }}>
                      <Checkbox
                        checked={bankTransfer}
                        style={{
                          fontWeight: 500,
                          color: "#0F0718",
                          fontSize: "1.25em",
                          transform: "scale(1.05)",
                          lineHeight: "normal",
                        }}
                        onChange={onChangeCheckbox}
                      >
                        Bank Transfer
                      </Checkbox>
                    </Form.Item>
                  ) : null}
                </Col>
                <Col span={2} />
              </Row>
            ) : (
              <Row>
                <Col span={2} />
                <Col span={10}>
                  <Form.Item name={"cashIn"} style={{ marginLeft: "8vw", fontSize: "1vw" }}>
                    {posConfig?.cashIn === "Y" ? (
                      <Checkbox
                        style={{
                          fontWeight: 500,
                          color: "#0F0718",
                          fontSize: "1.25em",
                          transform: "scale(1.05)",
                          lineHeight: "normal",
                        }}
                        checked={cashIn}
                        onChange={onChangeCheckbox}
                      >
                        Cash In
                      </Checkbox>
                    ) : null}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  {posConfig?.allowPettyCashIn === "Y" ? (
                    <Form.Item name={"pettyCashIn"} style={{ fontSize: "1vw" }}>
                      <Checkbox
                        checked={pettyCashIn}
                        style={{
                          fontWeight: 500,
                          color: "#0F0718",
                          fontSize: "1.25em",
                          transform: "scale(1.05)",
                          lineHeight: "normal",
                        }}
                        onChange={onChangeCheckbox}
                      >
                        Petty cash In
                      </Checkbox>
                    </Form.Item>
                  ) : null}
                </Col>
                <Col span={2} />
              </Row>
            )}
            <Row>
              {cashAddInFlag && pettyCashOut ? (
                <Col span={24}>
                  <Form.Item
                    name="expenseCategory"
                    label={
                      <div style={{ fontSize: "1vw" }}>
                        <span
                          style={{
                            color: "#0F0718",
                            fontSize: "1.25em",
                            fontWeight: "500",
                          }}
                        >
                          Expense Type
                        </span>
                      </div>
                    }
                    style={{ marginLeft: "7vw", width: "75%" }}
                    rules={[{ required: true, message: "Please select an expense type" }]}
                  >
                    <Select
                      placeholder="Select Type"
                      size="large"
                      style={{
                        fontSize: "1.15em",
                        width: "100%",
                        borderRadius: "4px",
                      }}
                      className="custom-select"
                      dropdownStyle={{ fontSize: "1.15em" }}
                    >
                      {expenseCategories.map((item) => (
                        <Option key={item.finExpCategoryId} value={item.finExpCategoryId}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              ) : null}
              {cashAddInFlag && bankTransfer ? (
                <Col span={24}>
                  <Form.Item
                    name="financialAccount"
                    label={
                      <div style={{ fontSize: "1vw" }}>
                        <span
                          style={{
                            color: "#0F0718",
                            fontSize: "1.25em",
                            fontWeight: "500",
                          }}
                        >
                          Financial Account
                        </span>
                      </div>
                    }
                    style={{ marginLeft: "7vw", width: "75%" }}
                    rules={[{ required: true, message: "Please select a financial account" }]}
                  >
                    <Select
                      placeholder="Select Type"
                      size="large"
                      style={{
                        fontSize: "1.15em",
                        width: "100%",
                        borderRadius: "4px",
                      }}
                      className="custom-select"
                      dropdownStyle={{ fontSize: "1.15em" }}
                    >
                      {(financialAccounts || []).map((item) => (
                        <Option key={item.fin_financial_acct_id} value={item.fin_financial_acct_id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              ) : null}
              <Col span={24}>
                <Form.Item
                  className="popUpForm"
                  style={{
                    marginLeft: "7vw",
                    fontSize: "1vw",
                  }}
                  name="amount"
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                        }}
                      >
                        {" "}
                        Amount{" "}
                      </span>
                    </div>
                  }
                  rules={[
                    {
                      required: true,
                      message: `Please enter amount`,
                    },
                  ]}
                >
                  <Input
                    ref={amountInputRef}
                    placeholder={`e.g, 100`}
                    size="large" // Handle input value changes
                    allowClear={false}
                    onFocus={() => setFocusedField("amount")}
                    onChange={handleAmountChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      height: "7.5vh",
                      width: "90%",
                      borderRadius: "4px",
                      border: "1px solid #fff",
                      fontSize: "1.15em",
                    }}
                  />
                </Form.Item>
              </Col>
              {cashAddInFlag && bankTransfer ? (
                <Col span={24}>
                  <Form.Item
                    style={{ marginLeft: "7vw", fontSize: "1vw" }}
                    label={
                      <div style={{ fontSize: "1vw" }}>
                        <span style={{ color: "#0F0718", fontSize: "1.25em", fontWeight: "500" }}>Financial File</span>
                      </div>
                    }
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <label
                        style={{
                          border: "1px solid #d9d9d9",
                          padding: "6px 16px",
                          borderRadius: "4px",
                          cursor: uploading ? "not-allowed" : "pointer",
                          background: uploading ? "#f5f5f5" : "#fff",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                          opacity: uploading ? 0.7 : 1,
                        }}
                      >
                        {uploading ? "Uploading..." : "Choose File"}

                        <input type="file" accept=".jpg,.jpeg,.png,.pdf" style={{ display: "none" }} disabled={uploading} onChange={(e) => handleFileUpload(e, "Financial File")} />
                      </label>

                      <span
                        style={{
                          fontSize: "13px",
                          color: "#595959",
                          maxWidth: "220px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {uploadedFileName || "No file chosen"}
                      </span>
                    </div>
                  </Form.Item>
                </Col>
              ) : (
                <Col span={24}>
                  <Form.Item
                    style={{
                      paddingBottom: 0,
                      marginLeft: "7vw",
                      fontSize: "1vw",
                    }}
                    className="popUpForm"
                    name="note"
                    label={
                      <div style={{ fontSize: "1vw" }}>
                        <span
                          style={{
                            color: "#0F0718",
                            fontSize: "1.25em",
                            fontWeight: "500",
                          }}
                        >
                          {" "}
                          Note{" "}
                        </span>
                      </div>
                    }
                    rules={[
                      {
                        required: true,
                        message: `Please enter note`,
                      },
                    ]}
                  >
                    <Input
                      placeholder={`Type to add a note`}
                      size="large"
                      onChange={(e) => {
                        handleCashInNote(e.target.value);
                      }}
                      onFocus={() => setFocusedField("note")}
                      allowClear={false}
                      style={{
                        height: "7.5vh",
                        width: "90%",
                        borderRadius: "4px",
                        border: "1px solid #fff",
                        fontSize: "1.15em",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "0px",
                        marginTop: "5px",
                        fontWeight: "500",
                        fontSize: "0.8em",
                        color: "#929098",
                      }}
                    >
                      Max Characters : 200
                    </p>
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Col>
          <Col span={3} />
          <Col span={10}>
            <Row gutter={[8, 8]}>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("1");
                    e.preventDefault();
                  }}
                >
                  1
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("2");
                    e.preventDefault();
                  }}
                >
                  2
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("3");
                    e.preventDefault();
                  }}
                >
                  3
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("x");
                    e.preventDefault();
                  }}
                >
                  <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                </button>
              </Col>
              <Col span={4} />
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("4");
                    e.preventDefault();
                  }}
                >
                  4
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("5");
                    e.preventDefault();
                  }}
                >
                  5
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management"
                  onClick={(e) => {
                    handleCashManagement("6");
                    e.preventDefault();
                  }}
                >
                  6
                </button>
              </Col>
              <Col span={5}>
                <button
                  className="amt-dial-btn-super-market-cash-management-cancel-discount"
                  onClick={() => {
                    if (focusedField === "note") {
                      cashManagementForm.setFieldsValue({ note: "" });
                    } else if (focusedField === "amount") {
                      cashManagementForm.setFieldsValue({ amount: "" });
                    }
                  }}
                >
                  Clear
                </button>
              </Col>
              <Col span={4} />
              <Col span={15}>
                <Row gutter={[8, 6]}>
                  <Col span={8}>
                    <button
                      className="amt-dial-btn-super-market-cash-management"
                      onClick={(e) => {
                        handleCashManagement("7");
                        e.preventDefault();
                      }}
                    >
                      7
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      className="amt-dial-btn-super-market-cash-management"
                      onClick={(e) => {
                        handleCashManagement("8");
                        e.preventDefault();
                      }}
                    >
                      8
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      className="amt-dial-btn-super-market-cash-management"
                      onClick={(e) => {
                        handleCashManagement("9");
                        e.preventDefault();
                      }}
                    >
                      9
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      className="amt-dial-btn-super-market-cash-management"
                      onClick={(e) => {
                        handleCashManagement("0");
                        e.preventDefault();
                      }}
                    >
                      0
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      className="amt-dial-btn-super-market-cash-management"
                      onClick={(e) => {
                        handleCashManagement("00");
                        e.preventDefault();
                      }}
                    >
                      00
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      className="amt-dial-btn-super-market-cash-management"
                      onClick={(e) => {
                        handleCashManagement(".");
                        e.preventDefault();
                      }}
                    >
                      .
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col span={5} style={{ paddingRight: 0 }}>
                <button
                  // id="sm-amount-buttonEnter"
                  className="amt-dial-btn-market-cash-management-discount"
                >
                  Enter
                </button>
              </Col>
              <Col span={4} />
            </Row>
            <Row style={{ marginTop: "3%" }}>
              <Button
                htmlType="submit"
                style={{
                  backgroundColor: "#2F3856",
                  color: "#fff",
                  width: "83.5%",
                  fontSize: "1.5em",
                  textAlign: "center",
                  fontWeight: "500",
                  borderRadius: "3px",
                  height: "7vh",
                }}
              >
                Done
              </Button>
            </Row>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default CashManagementDrawer;
